import { ImageProps } from 'next/image';
import { HTMLAttributeAnchorTarget, MouseEvent } from 'react';

import { IntrinsicElement } from '../../../../shared/utilities/types/IntrinsicElement';
import { SquareCard } from '../square/SquareCard';

interface FacetCardProps {
    href: string;
    image: ImageProps;
    target?: HTMLAttributeAnchorTarget;
    title: string;
    small?: boolean;
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
    titleElement?: IntrinsicElement;
}

export function FacetCard(props: FacetCardProps) {
    return <SquareCard {...props} />;
}

FacetCard.PICTURE_RATIO = SquareCard.PICTURE_RATIO;
